module.exports = __webpack_public_path__ + "img/r-cb6-1.48d59c9a.gif";